import type { NotificationItem } from '../api/types';

export function NotificationStrip({
  notifications,
  onOpenAccount,
  onMarkRead,
}: {
  notifications: NotificationItem[];
  onOpenAccount: (accountId: string) => void;
  onMarkRead: (notificationIds?: number[]) => void;
}) {
  if (notifications.length === 0) return null;

  return (
    <details className="notifstrip">
      <summary className="notifhead">
        <span className="notiflab">
          {notifications.length} unread update{notifications.length === 1 ? '' : 's'}
        </span>
      </summary>
      <div className="notifactions">
        <button
          type="button"
          className="btn"
          onClick={() => onMarkRead()}
        >
          Mark all read
        </button>
      </div>
      <ul className="notiflist">
        {notifications.map(item => (
          <li key={item.notification_id}>
            <button
              type="button"
              className="notifitem"
              onClick={() => {
                onOpenAccount(item.account_id);
                onMarkRead([item.notification_id]);
              }}
            >
              {item.text}
            </button>
          </li>
        ))}
      </ul>
    </details>
  );
}
